import { HxngMonetisation } from '../pages/utils';
import { Clinic } from '../store/types/prescription';
import { RenderPdfConfig } from '../Templar/types';
import { GET_DOC_PROFILE } from './constants';
import fetchWithRefresh from './fetchWithRefresh';
import { TemplateV2 } from './pushRenderPdfTemplateConfig';

export interface DocProfileResponse {
    _id: string;
    profile: Profile;
    created_at?: string;
    updated_at?: string;
    loginmeta?: {
        role?: 'ADMIN' | 'DOCTOR' | 'STAFF';
        docid?: string;
        switch?: boolean;
        userid?: string;
        username?: string;
    };
}
export interface Profile {
    personal: Personal;
    professional: Professional;
}
export interface Personal {
    name: Name;
    phone?: Phone;
    email?: string;
    gender?: string;
    dob?: string;
    pic?: string;
}
export interface Name {
    f: string;
    l: string;
}
export interface Phone {
    code: string;
    value: string;
}

export interface Template {
    templateId: string;
    displayName: string;
}
export interface Templates {
    print?: Template[];
    send?: Template[];
}

export interface Professional {
    registrations?: Registrations;
    degree: SpecialityEntityOrMajorSpeciality[];
    major_speciality?: SpecialityEntityOrMajorSpeciality;
    speciality?: SpecialityEntityOrMajorSpeciality[];
    default_clinic: string;
    invite?: {
        invite_code?: string;
        invite_link?: string;
    };
    language?: { code: string; value: string }[];
    templates?: Templates;
    templates_v2?: RenderPdfConfig[];
    signature: string;
    onboarded_for?: string[];
    username: string;
    clinics?: Clinic[];
    category?: string[];
    googleReviewLink?: string;
    header_text?: string;
    signature_text?: string;
    saas?: string;
    cs?: SuccessManager;
    saas_detail?: SaasDetail;
    businessId?: string;
    feature?: FeaturesStatus | null;
    'hxng-monetisation'?: HxngMonetisation;
    hpr_id?: string;
    hpr_id_number?: string;
    business?: {
        id: string;
        name?: string;
        logo?: string;
    };
}

export interface SuccessManager {
    training_status: string;
    success_manager: string;
    oid: string;
    training_start: string;
    training_end: string;
    last_connect: string;
}

export interface Registrations {
    council: string;
    id: string;
    medical_id: string;
    year: string;
}
export interface SpecialityEntityOrMajorSpeciality {
    id: string;
    name: string;
}
export interface FeaturesStatus {
    rn?: boolean;
}

export interface SaasDetail {
    start_date: string;
    status: boolean;
    date_of_collection: string;
    trial_start: string;
    valid_till: string;
    trial_end: string;
}

export default (docId?: string): Promise<DocProfileResponse> => {
    return fetchWithRefresh(GET_DOC_PROFILE(docId)).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('doc profile not found');
        }
    });
};
